{
  "limits": {
    "overlay": {
      "title": {
        "pdfExports": "Exportar plan a PDF",
        "importingLayers": "Importar capas",
        "teamWorkspace": "Espacio de trabajo en equipo",
        "team": "Crea equipos",
        "maximumUsers": "Agregar usuarios",
        "siteMaps": "Añadir mapas del sitio",
        "FlowRate": "Herramientas de análisis",
        "Capacity": "Herramientas de análisis",
        "layer3DTypes": "Crea una capa 3D",
        "iconAndModelUploads": "Cargue componentes 3D/Icon",
        "attributeDataExport": "Exportar a Excel",
        "sharedLinks": "Generar enlace",
        "imagesOnModels": "Imágenes personalizadas en modelos"
      },
      "content": {
        "text1": {
          "pdfExports": "Actualmente no tiene acceso para exportar el plan a PDF. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "importingLayers": "Actualmente no tienes acceso a la importación de capas de otros planes. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "teamWorkspace": "Actualmente no tienes acceso al espacio de trabajo del equipo. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "team": "En este momento, no tienes acceso para crear equipos en tu plan actual. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "maximumUsers": "Actualmente no tienes acceso para añadir más usuarios. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "maxTeamMaps": "¡Oh, no! Parece que te has quedado sin planes para tu plan. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "siteMaps": "En este momento, no tienes acceso a subir mapas del sitio en tu plan actual. Actualízate para integrar los dibujos CAD en tus planos.",
          "FlowRate": "Actualmente no tiene acceso a la herramienta de análisis del caudal de su plan actual. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "Capacity": "Actualmente no tienes acceso a la herramienta de análisis de capacidad de tu plan actual. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "customLogo": "Actualice para agregar su propio logotipo y marca",
          "layer3DTypes": "En este momento, no tienes acceso para crear capas 3D en tu plan actual. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "iconAndModelUploads": "Actualmente no tienes acceso para subir componentes 3D/Icon a tu plan actual. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "customLayer": "Tu plan actual no te permite crear capas personalizadas. Actualízate para crear más planes en colaboración con otros miembros del equipo.",
          "attributeDataExport": "Actualmente no tiene acceso para exportar a Excel. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo.",
          "sharedLinks": "Actualmente no tienes acceso a compartir el mapa. Actualízate para trabajar en los mapas en colaboración con otros miembros del equipo.",
          "sso": "Actualice su plan para configurar Sso",
          "imagesOnModels": "Actualmente no tienes acceso para subir imágenes personalizadas a tus modelos. Actualízate para trabajar en los planes en colaboración con otros miembros del equipo."
        },
        "text2": "Estas son algunas de las ventajas de una actualización:",
        "professional": {
          "1": "Espacio de trabajo compartido para tu equipo",
          "2": "Capas e íconos personalizables y flexibles",
          "3": "Integración de CAD y exportación de PDF"
        }
      }
    }
  }
}